import React from 'react';
/**
 * Apply the given class for modals and other required components.
 * Needed for widget "themed" class.
 */
const ThemedContext = React.createContext();

export default ThemedContext;
